var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path15, _circle1, _circle10, _circle11, _path16, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _path17, _path18, _path19, _path20, _rect8, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 241,
    viewBox: "0 0 374 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 91L102.5 71.5L106.5 67L121.5 81.5L145 52.5L150.5 57L122.5 91Z",
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52H75C75 90 60 83 61 118C61.8 146 86.6667 167.333 99 174.5H74.5H31V52Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 97V178H27.5V48.5H107.5L121 62",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 138V118.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 106H14",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 112H17",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138 162.5H154",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146 155L146 171",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79V88.5H84H103",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101V110.5H84H103",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65 124V133.5H84H103",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65 147V156.5H84H103",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 109,
    r: 70,
    fill: "#F58120"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 109,
    r: 58,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 109,
    r: 47,
    fill: "#F58120"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 109,
    r: 36,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 109,
    r: 26,
    fill: "#528FF5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 111,
    r: 69.5,
    stroke: "#192657"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 111,
    r: 57.5,
    stroke: "#192657"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 111,
    r: 46.5,
    stroke: "#192657"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 111,
    r: 35.5,
    stroke: "#192657"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 111,
    r: 25.5,
    stroke: "#192657"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.909 109.038L200.09 55.9619",
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.422 112.109L256.398 110.551L263.759 100.917L268.422 112.109Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.583 101.861L269.58 111.454L259.274 110.119L265.583 101.861Z",
    stroke: "#F58120"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M190 52.8198L195.21 51.3676L195.873 46.0001L204.208 53.1781L203.545 58.5456L198.335 59.9978L190 52.8198Z",
    fill: "#528FF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 179,
    width: 4,
    height: 47,
    fill: "#528FF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 169,
    width: 4,
    height: 57,
    fill: "#F58120"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 179,
    width: 4,
    height: 47,
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 169,
    width: 4,
    height: 57,
    fill: "#F58120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 162,
    width: 4,
    height: 64,
    fill: "#528FF5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 169,
    width: 4,
    height: 57,
    fill: "#F58120"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 156,
    width: 4,
    height: 70,
    fill: "#528FF5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M154 225.5H248.5",
    stroke: "black",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 42,
    r: 4,
    fill: "#528FF5"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.5,
    cy: 55.5,
    r: 4.5,
    fill: "#F58120"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.5,
    cy: 26.5,
    r: 4.5,
    fill: "#C4C4C4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M359 51.5L338 39.5L359 26",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 39,
    r: 5,
    stroke: "#1E334E",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 363,
    cy: 54,
    r: 5,
    stroke: "#1E334E",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 363,
    cy: 24,
    r: 5,
    stroke: "#1E334E",
    strokeWidth: 2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 343.5,
    cy: 185.5,
    r: 10.5,
    stroke: "#528FF5",
    strokeWidth: 2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 132.5,
    r: 6.5,
    fill: "#528FF5"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 115.5,
    r: 9.5,
    fill: "#F58120"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3364 155.013C10.3364 187.045 5.43642 248.641 89.8364 238.763C195.336 226.415 181.836 209.235 286.336 228.562C390.836 247.889 417.836 26.1672 270.336 41.1992C122.836 56.2312 182.836 251.647 307.336 203.33",
    stroke: "#888888",
    strokeWidth: 0.5,
    strokeLinecap: "square",
    strokeDasharray: "2 2 2 2 2 2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 72L117 91.5L149 52L139 44L116 72.5L107 63.5L104 66.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 22.5L128.5 40.5L190.5 41L157.5 22.5Z",
    stroke: "black",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M162.274 30L136 7H190L162.274 30Z",
    fill: "#F58120"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 1,
    width: 65,
    height: 40,
    stroke: "black",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M157.68 27L128 1H189L157.68 27Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDemo);
export default __webpack_public_path__ + "static/media/request-demo.35d40e762fc8f85a45ed93e4f290b8a5.svg";
export { ForwardRef as ReactComponent };